module.exports = __webpack_public_path__ + "media/images/area/feature/chugoku/hero_mob-6dbac3b442c66abbaa8b670d0f7bf7c0.jpg";